// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"226":"2ae1f4ec","453":"2dee7a69","857":"26f2fc74"}[chunkId] + ".chunk.js";
};